module.exports = __webpack_public_path__ + "static/media/csv-file-format.cf69775f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csv-file-format.svg
// module id = 385
// module chunks = 1